import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { en, enMeta } from './locales/en';
import { fr, frMeta } from './locales/fr';
import { de, deMeta } from './locales/de';
import { hi, hiMeta } from './locales/hi';

import { id, idMeta } from './locales/id';
import { it, itMeta } from './locales/it';
import { ja, jaMeta } from './locales/ja';
import { ko, koMeta } from './locales/ko';

import { pl, plMeta } from './locales/pl';
import { pt_BR, pt_BRMeta } from './locales/pt_BR';
import { zh_CN, zh_CNMeta } from './locales/zh_CN';
import { es, esMeta } from './locales/es';

import { th, thMeta } from './locales/th';
import { zh_TW, zh_TWMeta } from './locales/zh_TW';
import { tr, trMeta } from './locales/tr';
import { vi, viMeta } from './locales/vi';

export const languages = [
    enMeta,
    // frMeta,
    // deMeta,
    // hiMeta,

    // idMeta,
    // itMeta,
    // jaMeta,
    // koMeta,

    // plMeta,
    // pt_BRMeta,
    // zh_CNMeta,
    // esMeta,

    // thMeta,
    // zh_TWMeta,
    // trMeta,
    // viMeta,
];

const resources = {
    en,
    // fr,
    // de,
    // hi,

    // id,
    // it,
    // ja,
    // ko,

    // pl,
    // 'pt-BR': pt_BR, // pt_BR,
    // 'zh-CN': zh_CN, // zh_CN,
    // es,

    // th,
    // 'zh-TW': zh_TW, // zh_TW,
    // tr,
    // vi,
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        detection: {
            order: ['localStorage', 'querystring'],

            lookupLocalStorage: 'hl',
            lookupQuerystring: 'hl',

            caches: ['localStorage'],
            excludeCacheFor: ['cimode'],
        },
        resources,
        interpolation: {
            escapeValue: false,
        },
        fallbackLng: enMeta.lang_code,
        debug: false,
    });

export { i18n };
